import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { IconMenu, IconClose, IconPhone } from "../Icons/Icons";
import "../../assets/css/navbar.css";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Compliance", to: "/compliance" },
  { label: "Contact", to: "/contact" },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const isActive = (to) => {
    if (to === "/about") return pathname === "/about";
    if (to === "/contact") return pathname === "/contact";
    if (to === "/compliance") return pathname === "/compliance";
    if (to === "/") return pathname === "/" && !hash;
    if (to.startsWith("/#")) return pathname === "/" && hash === to.slice(1);
    return pathname === to;
  };

  return (
    <>
      <header className={`navbar ${scrolled || menuOpen ? "scrolled" : ""}`}>
        <nav className="container navbar-inner" aria-label="Main navigation">
          <Link
            to="/"
            className="navbar-logo"
            aria-label="Sustainability Advisory – home"
            onClick={closeMenu}
          >
            <img src={logo} alt="Sustainability Advisory Ltd logo" />
          </Link>

          <ul className={`navbar-links ${menuOpen ? "open" : ""}`}>
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.to}
                  className={`navbar-link ${isActive(link.to) ? "active" : ""}`}
                  onClick={closeMenu}
                >
                  {link.label}
                </Link>
              </li>
            ))}

            <li className="navbar-drawer-footer">
              <Link to="/contact" className="btn btn-primary navbar-drawer-cta" onClick={closeMenu}>
                Get in Touch
              </Link>
              <a href="tel:01984624989" className="navbar-drawer-phone">
                <IconPhone width={16} height={16} /> 01984 624989
              </a>
            </li>
          </ul>

          <div className="navbar-actions">
            <Link
              to="/contact"
              className="btn btn-primary navbar-cta"
              onClick={closeMenu}
            >
              Get in Touch
            </Link>
            <button
              type="button"
              className="navbar-toggle"
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((v) => !v)}
            >
              {menuOpen ? <IconClose /> : <IconMenu />}
            </button>
          </div>
        </nav>
      </header>
      <div
        className={`navbar-backdrop ${menuOpen ? "open" : ""}`}
        onClick={closeMenu}
      />
    </>
  );
}

export default Navbar;
